import { LS } from './storage';

// 화면 크기(배율): 4K 처럼 큰 화면에서는 글자·버튼이 너무 작게 보여서 페이지 전체를 CSS zoom 으로 키운다.
// 'auto' 는 창 너비로 정한다 (zoom 은 창 너비 값에 영향을 주지 않는다).
export const UI_SCALE_STEPS = [1, 1.25, 1.5, 1.75, 2];
const KEY = 'ui-scale';

const autoScale = () => {
    const w = window.innerWidth;
    if (w >= 3400) return 1.5;
    if (w >= 2800) return 1.25;
    return 1;
};

export const getUiScalePref = () => {
    const saved = Number(LS.get(KEY));
    return UI_SCALE_STEPS.includes(saved) ? saved : 'auto';
};

export const effectiveUiScale = (pref = getUiScalePref()) => (pref === 'auto' ? autoScale() : pref);

export const applyUiScale = () => {
    const scale = effectiveUiScale();
    const root = document.documentElement;
    root.style.zoom = scale === 1 ? '' : String(scale);
    root.style.setProperty('--ui-zoom', String(scale));
    return scale;
};

export const setUiScalePref = (pref) => {
    if (pref === 'auto') LS.remove(KEY); else LS.set(KEY, pref);
    return applyUiScale();
};

// zoom 이 걸려 있으면 마우스 좌표·getBoundingClientRect 는 화면 픽셀, style 의 px·scrollTop 은 확대 전 픽셀이다.
// 둘을 섞어 쓰는 곳에서는 화면 픽셀을 이 값으로 나눠야 한다.
export const uiZoom = () => document.documentElement.currentCSSZoom || parseFloat(getComputedStyle(document.documentElement).zoom) || 1;
